<div class="dialog-container">
  <div mat-dialog-title class="dialog-title">
    {{ title }}
  </div>

  <mat-dialog-content class="dialog-content">
    <strong *ngIf="emphasis" class="emphasis-text">{{ emphasis }}</strong>
    <p class="description">{{ description }}</p>

    <!-- Schema section - only displayed if schemas exist -->
    <div *ngIf="schemas && schemas.length > 0" class="schema-section">
      <p *ngIf="tableName" class="table-name">
        <strong>Table name:</strong> {{ tableName }}
      </p>

      <!-- Single schema display -->
      <div *ngIf="schemas.length === 1" class="single-schema">
        <p><strong>Schema:</strong> {{ schemas[0] }}</p>
      </div>

      <!-- Multiple schemas dropdown -->
      <div *ngIf="schemas.length > 1" class="multiple-schemas">
        <p><strong>Please select a schema:</strong></p>
        <mat-form-field appearance="outline" class="schema-select">
          <mat-label>Select Schema</mat-label>
          <mat-select [(ngModel)]="selectedSchema">
            <mat-option *ngFor="let schema of schemas" [value]="schema">
              {{ schema }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      *ngIf="showCancelButton"
      class="action-button cancel-button"
      mat-button
      (click)="onCancel()"
    >
      <mat-icon>cancel</mat-icon>
      <span>{{ cancelText }}</span>
    </button>
    <button
      class="action-button confirm-button"
      mat-raised-button
      color="primary"
      [disabled]="schemas && schemas.length > 1 && !selectedSchema"
      (click)="onConfirm()"
    >
      <mat-icon>check_circle</mat-icon>
      <span>{{ confirmText }}</span>
    </button>
  </mat-dialog-actions>
</div>
